import { Link } from "react-router-dom";

import Button from "@mui/material/Button";

import "../App.css";

function LoginCTA() {
  return (
    <div className="block cta">
      <div class="cta-content">
        <div class="cta-text">
          <h2>Start your food journey</h2>
          <ul class="cta-points">
            <li>👀 See who’s joining and when</li>{" "}
            <li>🍽️ Join or create your own foodie events</li>{" "}
            <li>🎉 Free full access for a year for the first 200 users</li>{" "}
          </ul>
          <Link to="/register">
            <Button color="primary" variant="contained">
              Join Fudopia free
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default LoginCTA;
